import {BaseDataBuilder, PrimitiveDataTypes} from './BaseDataBuilder'

export class TextualDataBuilder extends BaseDataBuilder {
    private readonly supportedDataTypes = ['text', 'number', 'url', 'image', 'dateTime']

    constructor(dataType: PrimitiveDataTypes, displayName: string, defaultValue: string) {
        super(dataType, displayName, defaultValue)
        if (!this.supportedDataTypes.includes(this.dataType)) {
            console.error(`Unsupported textual data type: ${this.dataType}`)
        }
    }
}
